// VARIABLES
// Colors
export const colors = {
	brandColor: '#2d32aa',
	brandSecondaryColor: '#00b8de',
	brandColorDark: '#171a67',
	greyScale: {
		dark: '#333',
		medium: '#ccc',
		ligth: '#e8e8e8',
	},
	error: '#f9423a',
	success: '#89ce23',
	warning: '#ff9d00',
	info: '#0089ff',
	white: '#fff',
	black: '#000',
};

// Fonts
export const fonts = {
	fontFamily: 'Karbon',
};

// Breakpoints
